import React from "react";
import { EditModalView } from "./EditModalView";
import { useIocContext } from "../../../contexts/ioc/IocContext";
import { EditModalProps } from "../models/types";
import { useEditStorage } from "../../../hooks/useEditStorage";
import { DischargeFields } from "../../../components/Storage/Fields/DischargeFields";
import { RetrievalFields } from "../../../components/Storage/Fields/RetrievalFields";
import { FooterFields, HeaderFields } from "../../../components/Storage";

export const EditModal: React.FC<EditModalProps> = ({
  open,
  data,
  onClose,
  isViewing = false,
}) => {
  const { serviceContainer } = useIocContext();

  const {
    formik,
    loading,
    nfs,
    isDischarge,
    scheduleDateValue,
    orderDateValue,
    setScheduleDate,
    setOrderDate,
    setVolumeRequested,
    setUnitPrice,
  } = useEditStorage({
    open,
    data,
    onClose,
    serviceContainer,
  });

  return (
    <EditModalView
      open={open}
      onClose={onClose}
      isLoading={Object.values(loading).some(Boolean)}
    >
      <HeaderFields
        data={data}
        formik={formik}
        isDischarge={isDischarge}
        isViewing={isViewing}
        scheduleDateValue={scheduleDateValue}
        setScheduleDate={setScheduleDate}
        scheduleTime={formik.values.scheduleTime}
        setScheduleTime={async (v) =>
          await formik.setFieldValue("scheduleTime", v)
        }
        orderDateValue={orderDateValue}
        setOrderDate={setOrderDate}
        setVolumeRequested={setVolumeRequested}
      />

      {isDischarge ? (
        <DischargeFields
          formik={formik}
          isViewing={isViewing}
          setUnitPrice={setUnitPrice}
        />
      ) : (
        <RetrievalFields formik={formik} isViewing={isViewing} nfs={nfs} />
      )}

      <FooterFields formik={formik} isViewing={isViewing} />
    </EditModalView>
  );
};
